import type { CSSProperties, ReactNode } from "react";

import styles from "./Chip.module.css";
import { cx } from "../lib/cx";

export type ChipProps = {
  readonly children: ReactNode;
  readonly className?: string;
  readonly repo?: boolean;
  readonly style?: CSSProperties;
};

export const Chip = ({
  children,
  className,
  repo = false,
  style,
}: ChipProps) => (
  <span
    className={cx(styles.chip, repo && styles.repo, className)}
    style={style}
  >
    {children}
  </span>
);
